export default __webpack_public_path__ + "static/media/Pens&Markers.16be1446.png";